// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var electionEventSlice = createSlice({
    name: "electionEvent",
    initialState: initialState,
    reducers: {
        setElectionEvent: function (state, action) {
            state[action.payload.id] = action.payload;
            return state;
        },
    },
});
export var setElectionEvent = electionEventSlice.actions.setElectionEvent;
export var selectElectionEventById = function (electionEventId) { return function (state) {
    if (electionEventId) {
        return state.electionEvent[electionEventId];
    }
    return undefined;
}; };
export default electionEventSlice.reducer;
